import React, {
  Dispatch,
  FC,
  SetStateAction,
  useEffect,
  useState,
} from "react";
import { getLabelName, isArabicCurrentLanguage, sortByDate } from "../../utils";
import { LoadingBox, GridTable, PrivilegesChecker, SearchBox } from "..";
import {
  GenericSearchRequestModel,
  RequestActionModel,
  ActionTypeEnum,
  paymentTypesApiResponseModel,
  PageEnum,
} from "../../models";
import { getAllPaymentTypes } from "../../serviceBroker/paymentTypeApiServiceBroker";
import { useSearchBox } from "../../hooks";

const getDisplayedPayments = (
  payments: paymentTypesApiResponseModel[],
  searchedWord: string
) => {
  const filteredData = payments.filter(
    ({ Name, EnglishName }) =>
      EnglishName.includes(searchedWord) || Name.includes(searchedWord)
  );
  return sortByDate(filteredData, "desc");
};

export const PaymentTypeList: FC<{
  setIsRefresh: Dispatch<SetStateAction<boolean>>;
  isRefresh: boolean;
  formId: PageEnum;
  onActionEvent: (o: RequestActionModel) => void;
}> = ({ setIsRefresh, isRefresh, onActionEvent, formId }) => {
  //#region state
  const { onChange, onSearch, searchedWord, value } = useSearchBox();
  const [searchParams] = useState<GenericSearchRequestModel>({
    pageSize: 10,
    pageNumber: 1,
  });
  const [data, setData] = useState<paymentTypesApiResponseModel[]>([]);
  const [loading, setLoading] = useState(false);
  const displayedData = getDisplayedPayments(data, searchedWord);

  //#endregion
  //#region useEffect
  useEffect(() => {
    const fillData = async () => {
      setLoading(true);
      setData(await getList());
      setLoading(false);
      setIsRefresh(false);
    };
    fillData().then(() => {});
  }, []);
  useEffect(() => {
    const fillData = async () => {
      if (isRefresh) {
        setLoading(true);
        setData(await getList());
        setLoading(false);
        setIsRefresh(false);
      }
    };
    fillData().then(() => {});
  }, [isRefresh]);
  //#endregion
  //#region functions
  const getList = async (): Promise<paymentTypesApiResponseModel[]> => {
    const paymentTypesList = await getAllPaymentTypes();
    return paymentTypesList !== null &&
      paymentTypesList !== undefined &&
      paymentTypesList.Result !== null &&
      paymentTypesList.Result !== undefined &&
      paymentTypesList.Result?.length !== 0
      ? paymentTypesList.Result
      : [];
  };
  //#endregion
  //#region html
  return (
    <>
      <PrivilegesChecker formId={formId} action="EnableSearch">
        <SearchBox
          name={getLabelName("Payments")}
          onChangeHandler={onChange}
          searchedWord={value}
          onSearchHandler={onSearch}
        />
      </PrivilegesChecker>
      {loading && <LoadingBox />}
      <GridTable
        //columns={columns}
        data={displayedData}
        totalRows={data.length}
        currentPage={searchParams.pageNumber}
        pageSize={searchParams.pageSize}
        // onCurrentPageChange={onCurrentPageChange}
        // onPageSizeChange={onPageSizeChange}
        paginationType="client"
        columnsProps={{
          actions: [ActionTypeEnum.Update, ActionTypeEnum.Delete],
          isArabic: isArabicCurrentLanguage(),
          onActionEvent,
        }}
        formId={PageEnum.PaymentType}
      />
    </>
  );
  //#endregion
};
